import React from "react";
import cx from "classnames";
import Alert from "../Alert";
import LoadingBar from "../LoadingBar";
import { useHistory, useParams, useLocation } from 'react-router-dom';
const isIOS = () => {
    return (navigator.userAgent.match(/iPhone/i) != null);
};
function PageLayout({ children, className, header, footer }) {
    const history = useHistory();
    const params = useParams();
    const location = useLocation();
    React.useEffect(() => {
        var _a, _b;
        const heading = (_b = (_a = document.querySelector('h1')) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim();
        if (heading) {
            document.title = heading;
            return;
        }
        if (!document.title.trim()) {
            document.title = 'Knowledge Base';
        }
    }, [location.pathname, location.search]);
    return (<main className={cx("page bg-color page-text-color", className)}>
      <LoadingBar />
      {header}
      <Alert />
      <div className="body body-height">
        <div className="body-wrapper">{children}</div>
      </div>
      {/* <div className={cx(
          {"submit-request-link": !isIOS()},
          className,
          { 'submit-request-link-ios': isIOS() }
        )}>
          <a
            href={`https://agency.comcate.com/private-submission/create?crm_token=${crmToken}&logout_redirect_url=http://herrimanut.comcate.com`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button
              className={cx(
                { 'submit-request': !isIOS() },
                { 'submit-request-ios': isIOS() }
              )}
            >
                <FontAwesomeIcon icon={faEnvelope} size="lg" transform="left-4"/> <span>Submit Request</span>
              </button>
          </a>
        </div> */}
      {footer}
    </main>);
}
export default PageLayout;
